let sub_scripts = document.getElementById("subCDN").dataset;
let sub_shop_currency = sub_scripts.moneyformat;
let money_format_sub = function (t, r) {
    function e(t, r) {
        return void 0 === t ? r : t;
    }
    function a(t, r, a, o) {
        if (
            ((r = e(r, 2)),
                (a = e(a, ",")),
                (o = e(o, ".")),
            isNaN(t) || null == t)
        )
            return 0;
        t = (t / 100).toFixed(r);
        var n = t.split(".");
        return (
            n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
            (n[1] ? o + n[1] : "")
        );
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        i = r || this.money_format;
    switch (i.match(n)[1]) {
        case "amount":
            o = a(t, 2);
            break;
        case "amount_no_decimals":
            o = a(t, 0);
            break;
        case "amount_with_comma_separator":
            o = a(t, 2, ".", ",");
            break;
        case "amount_with_space_separator":
            o = a(t, 2, " ", ",");
            break;
        case "amount_with_period_and_space_separator":
            o = a(t, 2, " ", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            o = a(t, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            o = a(t, 0, ".", "");
            break;
        case "amount_with_space_separator":
            o = a(t, 2, ",", "");
            break;
        case "amount_with_apostrophe_separator":
            o = a(t, 2, "'", ".");
    }
    return i.replace(n, o);
};
let CurrentProductUpdateJson, CurrentProductSubscripation;
function applyDiscountCode(discountCode) {
  const url = window.location.origin+'/discount/'+discountCode;
  fetch(url, {
    method: 'GET', // Add a body if required (Shopify discount URLs typically don't need one)
  })
    .then(response => {
      if (response.ok) {
        console.log('Discount applied successfully.');
      } else {
        console.error('Failed to apply the discount:', response.status);
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

function removeDiscountCode(cartData,r) {
  fetch('/discount/shiftaroma_empty_discount_code', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(response => response.json())
    .then(data => {
      console.log('Discount code removed successfully:', data);
    })
    .catch(error => {
    });
}

// New JS
window.getwcCartObject = function(currentLinekey){
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(cartData => {
      const find_p = (cartData.items).find((e) => e.key == currentLinekey);
      CurrentProductUpdateJson = find_p;
      if(find_p){
        const item_prop = find_p?.properties;
        if(item_prop?.__selling_p_id){
          CurrentProductSubscripation = cartData.items.find((f) => f.properties && Object.entries(f.properties).find((p) => f.product_id == item_prop?.__selling_p_id && p[0] == '__normal_p_id' && p[1] == find_p.product_id));
        }
      }
  })
  .catch(error => {
    console.error('Error fetching cart details:', error);
  });
}
const wcremoveAddonProduct = async function(r){
  const ID = CurrentProductSubscripation?.key;
    let data_json = {id: ID, quantity:0};
    await fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data_json)
    })
    .then((response) => response.json())
    .then((cart_result) => {
      removeDiscountCode(cart_result,'');
      var n = r.cleanCartResponse(cart_result);
      Udesly.dispatch("cart-updated", n);
    })
    .catch((cart_error) => {
        console.error(cart_error);
    });
}
const wcAddonDiscountAdd = async function(currentQty,r){
  const item_prop = CurrentProductUpdateJson?.properties;
  let current__selling_p_id, current___normal_p_pd;
  if(item_prop?.__selling_p_id && item_prop?.__normal_p_pd){
    current__selling_p_id = item_prop?.__selling_p_id;
    current___normal_p_pd = item_prop?.__normal_p_pd;
  }
  
    fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(cartData => {
    let discountFound = false;
    if(cartData.items){
       const getRightJSon = cartData.items.find((f) => f.properties && Object.entries(f.properties).find((p) =>  p[0] == '__selling_p_id' && p[1] == current__selling_p_id || p[0] == '__normal_p_id' && p[1] == current___normal_p_pd));
       if(getRightJSon){
         if(currentQty > 1){
           removeDiscountCode(cartData,'');
           console.log("qty is > 1");
         }else if(currentQty == 1){
           applyDiscountCode('1RZGGHW6XQNZ');
           console.log("qty is == 1");
         }else{
           // removeDiscountCode(cartData,'');
           console.log("any other option");
         }
       }
      // const find_p = (cartData.items).find((e) => e.id == t);
    }
  })
  .catch(error => {
    console.error('Error fetching cart details:', error);
  });
}
// End New JS

window.utterbondCartUpdate = function(e,t){
     fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(cartData => {
       // Udesly.dispatch("cart-updated", cartData);
      if(cartData.items){
        const find_p = (cartData.items).find((e) => e.id == t);
        if(find_p){
          let find_s_p = find_p.properties && Object.entries(find_p.properties).find((p) => p[0] == '__selling_p_id');
          if(find_s_p){
            const p_id = find_s_p[1];
            const g_find_s_p = cartData.items.find((d) => d.product_id == p_id);
            if(g_find_s_p && e == 0){
              removeAddonProduct(g_find_s_p.id.toString(),0);
              return utterbondCartJsonNew(e,t);
            }else{
              return utterbondCartJsonNew(e,t);  
            }
          }else{
            return utterbondCartJsonNew(e,t);
          }
        }else{
        }
      }
    })
    .catch(error => {
      console.error('Error fetching cart details:', error);
    });
}
const removeAddonProduct = async(vid,qty) =>{
  let data_json = {id: vid, quantity:qty};
    await fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data_json)
    })
        .then((response) => response.json())
        .then((cart_result) => {
        })
        .catch((cart_error) => {
            console.error(cart_error);
        });
}
window.utterbondCartJsonNew = function(e,t){
  // console.log("t", t);
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(cartData => {
    let discountFound = false;
    if(cartData.items){
      const find_p = (cartData.items).find((e) => e.id == t);
      if(find_p){
        const item_prop = find_p?.properties;
        let find_s_p = '';
        if(item_prop?.__selling_combo_product){
          find_s_p = cartData.items.find((f) => f.properties && Object.entries(f.properties).find((p) => p[0] == '__selling_p_id' && p[1] == find_p.product_id));
          if(find_s_p && e < 1){
            removeDiscountCode(cartData,'');
            return true;
          }
          // else if(find_s_p && 1 >= e){
          //   applyDiscountCode('1RZGGHW6XQNZ');
          //   return false;
          // }
        }else{
           find_s_p = (cartData.items).find((f) => f.product_id == item_prop?.__selling_p_id);
              if(e > find_p.quantity && !find_s_p){
                 removeDiscountCode(cartData,'');
                return true;
              }else if(e == 1 && find_s_p){
                applyDiscountCode('1RZGGHW6XQNZ');
                return true;
              }else{
                 removeDiscountCode(cartData,'');
                return true;
              }

        }

      }
    }
    if (!discountFound) {
      console.log('No discounts found in the cart.');
    }
   
  })
  .catch(error => {
    console.error('Error fetching cart details:', error);
  });
}
window.utterbondCartJson = function(r) {
    fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(cartData => {
    let discountFound = false;
    cartData.items.forEach(function (item) {
      console.log("item", item);
      const item_prop = item?.properties;
      if(!item_prop?.__selling_combo_product){
        const find_p = (cartData.items).find((e) => e.product_id == item_prop?.selling_p_id);
        if(!find_p){
          removeDiscountCode(cartData,r);
            // var n = r.cleanCartResponse(cartData);Udesly.dispatch("cart-updated",n)
        }
      }
       Udesly.dispatch("cart-updated", '');
      // normal_p_pd
      // if(item.)
      // if (item.discounts && item.discounts.length > 0) {
      //   discountFound = true;
      //   console.log('Discount found:', item.discounts[0].title);
      //   // removeDiscountCode();
      // }
    });

    if (!discountFound) {
      console.log('No discounts found in the cart.');
    }
   
  })
  .catch(error => {
    console.error('Error fetching cart details:', error);
  });
}
const onSubmitAddtoCart = async(add_cart_paylaod) =>{
  let data_json = {items: add_cart_paylaod};
    await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data_json)
    })
        .then((response) => response.json())
        .then((cart_result) => {
          applyDiscountCode('1RZGGHW6XQNZ');
          // window.location.href = '/cart';
          setTimeout(function(){
             Udesly.dispatch("product-added", '');
          document.querySelector('.cart-button').click();
          },1000);
        })
        .catch((cart_error) => {
            console.error(cart_error);
        });
}
function SubOnSubmitform(){
  let add_cart_paylaod = [];
  if(document.querySelector('.subscription_form_submit')){
    document.querySelector('.subscription_form_submit').addEventListener('click', function(){
      // debugger;
      const all_sub_plans = document.querySelectorAll('.item-utterbond-item-subscription');
      const current_plan_checkbox = Array.from(all_sub_plans).find((e) => e.checked && e.closest('.is-active-item'));
      if(current_plan_checkbox.closest('.utterbond-item')){
        if(current_plan_checkbox.closest('.utterbond-item').querySelector('select')){
          const selected_sub = current_plan_checkbox.closest('.utterbond-item').querySelector('select');
          var selectedOption = selected_sub.options[selected_sub.selectedIndex];
          const current_v_id = selectedOption.getAttribute('data-current_vid');
          const current_p_id = selectedOption.getAttribute('data-current_pid');
          const selected_product_v_id = selectedOption.getAttribute('data-variant_id');
          const selected_product_id = selectedOption.getAttribute('data-product_id');
          const selected_selling_id = selectedOption.value;
          
          add_cart_paylaod = [
            {
              id: current_v_id,
              quantity: 1,
              properties:{'__normal_p_pd':current_p_id,'__selling_p_id':selected_product_id}
            },
            {
              id: selected_product_v_id,
              quantity: 1,
              selling_plan: selected_selling_id,
              properties:{'__selling_combo_product':1,'__normal_p_id':current_p_id}
            }
          ];
          onSubmitAddtoCart(add_cart_paylaod);
        }
      }
    });
  }
}
function onchangeSellingPlan(){
  if(document.querySelectorAll('.item-utterbond-item-subscription')){
    document.querySelectorAll('.item-utterbond-item-subscription').forEach(function(this_click){
        this_click.addEventListener('change', function(){

         if(this_click.checked){
           document.querySelectorAll('.utterbond-item').forEach(function(this_val){
             this_val.classList.remove('is-active-item');
           });
           this_click.closest('.utterbond-item').classList.add('is-active-item');
         }
          if(this_click.checked && this_click.getAttribute('id') == 'item-utterbond-item-subscription'){
            if(this_click.closest('.utterbond-item').querySelector('.item_additional_information')){
              this_click.closest('.utterbond-item').querySelector('.item_additional_information').classList.add('is-show');
               var selling_plan_id = this_click.closest('.utterbond-item').querySelector('.item-product-list select').value;
              if(document.querySelector('[name="selling_plan"]')){
                document.querySelector('[name="selling_plan"]').value = selling_plan_id;
              }
            }
            if(document.querySelectorAll('[name="id"]')){
                document.querySelectorAll('[name="id"]').forEach(function(this_form){
                  if(this_form.closest('form[action="/cart/add"]')){
                    if(this_form.closest('form[action="/cart/add"]').querySelector('input[type="submit"]')){
                      this_form.closest('form[action="/cart/add"]').querySelector('input[type="submit"]').classList.add('subscription_form_submit');
                      this_form.closest('form[action="/cart/add"]').querySelector('input[type="submit"]').setAttribute('type','button');
                    } 
                  }
                });
              SubOnSubmitform();
            }
          }
          else{
            if(document.querySelectorAll('.item_additional_information')){
              document.querySelectorAll('.item_additional_information').forEach(function(this_click){
                this_click.classList.remove('is-show');
              });
            }
            if(document.querySelector('[name="selling_plan"]')){
              document.querySelector('[name="selling_plan"]').value = '';
            }
            if(document.querySelectorAll('[name="id"]')){
                document.querySelectorAll('[name="id"]').forEach(function(this_form){
                  if(this_form.closest('form[action="/cart/add"]')){
                    if(this_form.closest('form[action="/cart/add"]').querySelector('input[type="button"]')){
                      this_form.closest('form[action="/cart/add"]').querySelector('input[type="button"]').classList.remove('subscription_form_submit');
                      this_form.closest('form[action="/cart/add"]').querySelector('input[type="button"]').setAttribute('type','submit');
                    } 
                  }
                });
            }
          } 
        });
    });
  }
}

function update_price(){
  if(document.querySelectorAll('.item_additional_information')){
    document.querySelectorAll('.item_additional_information').forEach(function(this_selector){
      if(this_selector.querySelector('select')){
        const selectBox = this_selector.querySelector('select');
        var selectedOption = selectBox.options[selectBox.selectedIndex];
        const regular_price = selectedOption.getAttribute('data-price');
        const discount_price = selectedOption.getAttribute('data-discount_price');
        const closest_div = this_selector.closest('label');
        if(closest_div){
          if(closest_div.querySelector('.item_price_meta')){
            if(closest_div.querySelector('.item_price_meta .item_regular_price')){
               // closest_div.querySelector('.item_price_meta .item_regular_price').innerHTML =  money_format_sub(regular_price, sub_shop_currency);
            }
            if(closest_div.querySelector('.item_price_meta .item_compare_price')){
               // closest_div.querySelector('.item_price_meta .item_compare_price').innerHTML = money_format_sub(discount_price, sub_shop_currency);;
            }
          }
        }
      }
    });
  }
}

function update_option(){
  if(document.querySelectorAll('.item_additional_information')){
    document.querySelectorAll('.item_additional_information').forEach(function(this_selector){
      if(this_selector.querySelector('select')){
        this_selector.querySelector('select').addEventListener('change', function(e){
          e.preventDefault();
          e.stopPropagation();
          update_price();
          var selling_plan_id = this_selector.querySelector('select').value;
          if(document.querySelector('[name="selling_plan"]')){
            document.querySelector('[name="selling_plan"]').value = selling_plan_id;
          }
        });
      };
    });
  }
  if(document.querySelector('.cart_action_section button')){
    document.querySelector('.cart_action_section button').addEventListener('click', function(){
      const selected_sub = Array.from(document.querySelectorAll('.utterbond-item')).find((e) => e.querySelector('input[name="utterbond-subscription"]').checked)
      var selectedOption = selected_sub.options[selectBox.selectedIndex];
    });
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  onchangeSellingPlan();
  update_price();
  update_option();
  if(document.querySelector('.product-hero-add-to-cart-wrapper label[for="item-utterbond-item-subscription"]')){
    document.querySelector('.product-hero-add-to-cart-wrapper label[for="item-utterbond-item-subscription"]').click();
  }
});